import $ from 'jquery';
import '../../../node_modules/slick-carousel/slick/slick.js';

$(document).ready(function () {
  const prevBtn = '<div class="prev"><i class="icon icon-miniarrowleft"></i></div>';
  const nextBtn = '<div class="next"><i class="icon icon-miniarrowright"></i></div>';

  // Mise en forme spécifique de la pagination
  function pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  if (('[js-flex-slider]').length) {
    $('[js-flex-slider]').slick({
      dots: true,
      appendArrows: $('[js-reviews-arrows]'),
      appendDots: $('[js-reviews-dots]'),
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      mobileFirst: true,
      nextArrow: nextBtn,
      prevArrow: prevBtn,
      speed: 500,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      responsive: [
        {
          breakpoint: 960,
          settings: {
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 4000
          }
        },
        {
          breakpoint: 1280,
          settings: {
            draggable: false,
          }
        }
      ]
    });

    $.fn.clickToggle = function (func1, func2) {
      var funcs = [func1, func2];
      this.data('toggleclicked', 0);
      this.click(function () {
        var data = $(this).data();
        var tc = data.toggleclicked;
        $.proxy(funcs[tc], this)();
        data.toggleclicked = (tc + 1) % 2;
      });
      return this;
    };

    $('.pause').clickToggle(function () {
      $('[js-flex-slider]').slick('slickPause');
      $(this).toggleClass("play");

    }, function () {
      $('[js-flex-slider]').slick('slickPlay');
      $(this).toggleClass("play");
    });

    var totalSlidesValue = $('.slick-dots > li').length;
    var totalSlides = document.createElement("span");
    totalSlides.innerHTML = pad(totalSlidesValue);
    totalSlides.id = "slick-total-slides";
    $('[js-reviews-dots]').append(totalSlides);

  }


  /**************************************************
   *              HOME SLIDER
   ***************************************************/
  const homeSlider = $('[js-home-slider]');
  if (homeSlider.length) {
    let sliderTime = homeSlider.attr('data-slider-time');
    $('[js-home-slider]').slick({
      dots: false,
      appendArrows: $('[js-home-arrows]'),
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      mobileFirst: true,
      nextArrow: nextBtn,
      prevArrow: prevBtn,
      speed: 500,
      autoplaySpeed: sliderTime ?  sliderTime : 500,
      fade: true,
      adaptiveHeight: false,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    });
  }
});
